import React from "react";
import PropTypes from "prop-types";
import range from "lodash-es/range";

import { gatherClasses } from "../../lib/utils";

import "./spinner.scss";

const Spinner = props => {
  const { dataTestId, size } = props;
  return (
    <div
      data-testid={dataTestId}
      className={gatherClasses(props, "oui-spinner", `oui-spinner-${size}`)}
    >
      {range(16).map(val => (
        <div key={val} />
      ))}
    </div>
  );
};

Spinner.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  dataTestId: PropTypes.string
};

Spinner.defaultProps = {
  size: "md",
  dataTestId: "orion-spinner"
};

Spinner.displayName = "OrionSpinner";

export default Spinner;
